import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from 'context/AuthProvider';
import RequireAuth from 'views/RequireAuth';
import { routes } from 'routes';
import MainTemplate from 'templates/MainTemplate';
import Slips from 'views/Slips';
import Pits from 'views/Pits';
import User from 'views/User';
import ContactFormPage from 'views/ContactFormPage';
import LoginStandardPage from 'views/LoginStandardPage';
import LoginFirstPage from 'views/LoginFirstPage';
import LoginAdminPage from 'views/LoginAdminPage';
import PasswordChangePage from 'views/PasswordChangePage';
import AdminPage from 'views/AdminPage';
import AdminLogsPage from 'views/AdminLogsPage';
import AdminSettingsPage from 'views/AdminSettingsPage';
import RodoPage from 'views/RodoPage';
import Layout from 'views/Layout';
import Unauthorized from 'views/Unauthorized';

const ROLES = {
  User: 'user',
  Admin: 'admin',
};

const Root = () => (
  <BrowserRouter>
    <AuthProvider>
      <MainTemplate>
        <Routes>
          <Route path={routes.home} element={<Layout />}>
            <Route exact path={routes.login} element={<LoginStandardPage />} />
            <Route exact path={routes.first_login} element={<LoginFirstPage />} />
            <Route exact path={routes.password_change} element={<PasswordChangePage />} />
            <Route exact path={routes.admin_login} element={<LoginAdminPage />} />
            <Route exact path={routes.rodo} element={<RodoPage />} />
            <Route path={routes.unauthorized} element={<Unauthorized />} />

            <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
              <Route exact path={routes.home} element={<Navigate replace to="/slips" />} />
              <Route exact path={routes.user} element={<User />} />
              <Route exact path={routes.slips} element={<Slips />} />
              <Route exact path={routes.pits} element={<Pits />} />
              <Route exact path={routes.contact_form} element={<ContactFormPage />} />
            </Route>

            <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
              <Route exact path={routes.admin} element={<AdminPage />} />
              <Route exact path={routes.admin_settings} element={<AdminSettingsPage />} />
              <Route exact path={routes.admin_logs} element={<AdminLogsPage />} />
            </Route>
          </Route>
        </Routes>
      </MainTemplate>
    </AuthProvider>
  </BrowserRouter>
);

export default Root;
